import React from 'react';
import { motion } from 'framer-motion';
import { TECH_FEATURES } from '../../data/techFeatures';
import { KersIcon } from './TechIcons';

export function AERSystem() {
  const data = TECH_FEATURES.find(f => f.id === 'aer');
  if (!data) return null;

  return (
    <section id="aer" className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">

          {/* Visual Side */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative flex items-center justify-center py-12 order-2 lg:order-1"
          >
            {/* Decorative Rings */}
            <div className="absolute w-80 h-80 rounded-full border border-emerald-200" />
            <div className="absolute w-96 h-96 rounded-full border border-emerald-100" />

            {/* Glow Effect */}
            <motion.div
              className="absolute w-64 h-64 bg-gradient-to-tr from-emerald-500/10 to-transparent rounded-full blur-3xl"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.3, 0.5, 0.3]
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />

            {/* Icon */}
            <motion.div
              className="relative z-10"
              animate={{ rotate: 360 }}
              transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
            >
              <KersIcon className="w-48 h-48 text-emerald-500" />
            </motion.div>

            {/* Particles */}
            {[...Array(6)].map((_, i) => (
              <motion.div
                key={i}
                className="absolute w-2 h-2 bg-emerald-500 rounded-full"
                style={{ left: '50%', top: '50%' }}
                animate={{
                  x: [0, Math.cos(i * 60 * Math.PI / 180) * 120],
                  y: [0, Math.sin(i * 60 * Math.PI / 180) * 120],
                  opacity: [1, 0],
                  scale: [1, 0.5]
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  delay: i * 0.3,
                  ease: "easeOut"
                }}
              />
            ))}
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8 order-1 lg:order-2"
          >
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-100 text-emerald-700 text-sm font-medium mb-4">
                Tecnología KERS
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
                {data.title}
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed mb-6">
                {data.description}
              </p>
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-6 border-t border-gray-200">
              {data.benefits.map((benefit, idx) => (
                <div key={idx}>
                  <div className="text-lg font-bold text-emerald-600 mb-1">{benefit.title}</div>
                  <div className="text-gray-500 text-sm">{benefit.description}</div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
